import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import BooksFormErrorMessage from '../../../../components/books/model1/forms/BooksFormErrorMessage';

type InnerProps = InjectedIntlProps;

export enum ErrorType {
  Blank = 'blank',
  Failed = 'failed',
  Taken = 'taken',
  Invalid = 'invalid',
}

const BlankMessage: React.SFC<InnerProps> = ({ intl }) => (
  <BooksFormErrorMessage>
    {intl.formatMessage({
      id: `books.errors.login.blank`,
      defaultMessage: intl.formatMessage({ id: 'books.errors.blank' }),
    })}
  </BooksFormErrorMessage>
);

const FailedMessage: React.SFC<InnerProps> = ({ intl }) => (
  <BooksFormErrorMessage>
    {intl.formatMessage({
      id: `books.errors.login.failed`,
      defaultMessage: intl.formatMessage({
        id: 'books.errors.failed',
      }),
    })}
  </BooksFormErrorMessage>
);

const ERROR_COMPONENTS: {
  // tslint:disable-next-line:no-any
  [error in ErrorType]: React.ComponentClass | undefined;
} = {
  [ErrorType.Blank]: injectIntl(BlankMessage),
  [ErrorType.Taken]: undefined,
  [ErrorType.Invalid]: undefined,
  [ErrorType.Failed]: injectIntl(FailedMessage),
};

interface Props {
  errors?: ErrorType[];
}

class InputBookingWaitingListErrorMessage extends React.Component<Props> {
  public render() {
    const { errors } = this.props;
    if (!errors) {
      return null;
    }
    if (errors.length === 0) {
      return null;
    }
    return errors.map((error, index) => {
      const Component = ERROR_COMPONENTS[error];
      if (!Component) {
        return null;
      }
      return <Component key={index} />;
    });
  }
}

export default InputBookingWaitingListErrorMessage;
